export const paymentTypes = {
  pix_key: 'Chave Pix',
  pix_qr_code_static: 'Pix QR Code Estático',
  pix_qr_code_dynamic: 'Pix QR Code Dinâmico',
  charge_boleto: 'Boleto',
  charge_boleto_qr_code: 'Boleto QR Code',
  charge_pix_qr_code_dynamic: 'Pix',
  manual: 'Manual'
};
